import React from "react";

function Colors_2017() {
  return (
    <div>
      <h1>Colors_2017 Component</h1>
      <p>This is the Colors 2017 tutorial page content.</p>
    </div>
  );
}

export default Colors_2017;
